import styled from 'styled-components'
import theme from '../../styles/theme'
const H1 = styled.h1`
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
  margin: 0 0 16px 0;
  color: ${theme.color.black};
`

const H2 = styled.h2`
  font-size: 20px;
  line-height: 28px;
  font-weight: 700;
  margin: 0 0 16px 0;
  color: ${theme.color.black};
`

const H3 = styled.h3`
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
  margin: 0 0 16px 0;
  color: ${theme.color.black};
`

export { H1, H2, H3 }
